import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip as ReactstrapTooltip } from 'reactstrap'

import './tooltipStyles.scss'

const Tooltip = (props) => {
  const {
    target = null,
    text = '',
    isOpen = false,
    className = '',
    placement = 'auto',
    hideArrow = false
  } = props

  if (!target) {
    return null
  }

  return <ReactstrapTooltip
    isOpen={isOpen}
    hideArrow={hideArrow}
    placement={placement}
    className={className}
    innerClassName='ducs-tooltip'
    target={target}
  >
    {text}
  </ReactstrapTooltip>
}

Tooltip.defaultProps = {
  target: null,
  text: '',
  isOpen: false,
  className: '',
  placement: 'auto',
  hideArrow: false
}

Tooltip.propTypes = {
  target: PropTypes.element,
  text: PropTypes.string,
  isOpen: PropTypes.bool,
  className: PropTypes.string,
  placement: PropTypes.string,
  hideArrow: PropTypes.bool
}

export default Tooltip
